<template>
  <div>
    <div class="container-fluid">
      <div class="row game_penalty_page">
        <div class="container postgame">
          <div class="game_section">
            <div class="header">
              <div class="points_block">
              </div>
            </div>
            <h1>{{ getTranslations.post_game_bonus_game }}</h1>
            <h2>
              {{ getTranslations.post_game_score_penalty }}
            </h2>
              <img src="static/images/bg_menu.png" class="iframe_cover">
            <button type="button" @click.prevent="goToAddOnGame">{{ getTranslations.post_game_play_now }}</button>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer-main">
      <div class="containers">
        <nav class="footer-nav">
          <ul class="footer-nav__list">
            <li><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_t_and_c }}</a></li>
            <li><div class="divider"></div></li>
            <li><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')" target="_blank">{{ getTranslations.visitor_visitor_privacy_policy }}</a></li>
          </ul>
        </nav>
      </div>
    </footer>
  </div>
</template>

<script>
/* eslint no-console: "off" */
/* games_postgame_1-2-3.html */
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'post-game-add-on',
  data() {
    return {
      totalEarnedPoints: 0,
      payOutPoints: 0,
      riskPoints: 0,
      gameId: null,
    };
  },
  created() {
    console.log('in PostGame created hook');
    if (!this.$route.params.gameId) this.$router.push('/home');
    this.gameId = this.$route.params.gameId;
    this.totalEarnedPoints = this.homePlayerTotalEarnedPoints;
    console.log('this.totalEarnedPoints:', this.totalEarnedPoints);
    this.pointsForPayOutAndRisk();
  },
  beforeRouteLeave(to, from, next) {
    console.log('==> inside component\'s beforeRouteLeave:');
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    if (['/home', '/addOnGame'].includes(to.path)) next();
    else next({ path: '/home' });
  },
  methods: {
    ...mapMutations('game', [
      'setAddOnGameData',
    ]),
    goToHomePage() {
      this.$router.push('/home');
      window.location.reload();
    },
    goToAddOnGame() {
      this.$router.push({ name: 'addOnGame', params: { gameId: this.gameId } });
    },
    pointsForPayOutAndRisk() {
      if (this.addOnMode.lostPointsForMissedAddOnGame) {
        this.riskPoints = Math.floor(this.totalEarnedPoints / this.addOnMode.factor);
        this.payOutPoints = this.totalEarnedPoints * this.addOnMode.factor;
      } else if (!this.addOnMode.lostPointsForMissedAddOnGame) {
        this.riskPoints = 0;
        this.payOutPoints = this.totalEarnedPoints * this.addOnMode.factor;
      }
      const payload = {
        gameId: this.gameId, correctAnswers: this.$route.params.correctAnswers, riskPoints: this.riskPoints, payOutPoints: this.payOutPoints,
      };
      this.setAddOnGameData(payload);
    },
  },
  computed: {
    ...mapState('common', [
      'addOnMode',
      'userDetails',
      'multiOperatorInfo',
    ]),
    ...mapState('game', [
      'homePlayerTotalEarnedPoints',
      'gameID',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addongame/PostGameAddOn.vue